import { Component, Input } from '@angular/core';
import { Invoice } from '../../invoice.model';
import { InvoiceServiceProvider } from '../../../../../../shared/services/invoice/invoice-service/invoice.service';

@Component({
	selector: 'invoice-info-table',
	template: require('./invoice-info-table.html'),
	styles: [require('./invoice-info-table.scss')]
})
export class InvoiceInfoTableComponent {
	get invoice(): number {
		return this.invoice;
	}

	@Input('invoice')
	set product(value: Invoice) {
		this.data = value;
		this.setInvoiceStamp();
	}

	data: Invoice;
	imageStatusInvoice = '';

	constructor(private invoiceService: InvoiceServiceProvider) {}

	ngOnInit() {
		this.setInvoiceStamp();
	}

	setInvoiceStamp() {
		this.imageStatusInvoice = this.invoiceService.getInvoiceStampImageSrc(
			this.data.sent
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.ts